var React = require('react');

function Shapeh1Inline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Tracé_200","opacity":"6.400000e-02","fill":"#0076AE","enableBackground":"new    ","d":"M0,537.3V408.2\n\tC0,182.8,182.8,0,408.2,0h276.2v129.1c0,225.5-182.8,408.2-408.2,408.2H0z"}));
}

Shapeh1Inline.defaultProps = {"version":"1.1","id":"Graphic_element_homepage","x":"0px","y":"0px","viewBox":"0 0 684.5 537.3","enableBackground":"new 0 0 684.5 537.3","xmlSpace":"preserve"};

module.exports = Shapeh1Inline;

Shapeh1Inline.default = Shapeh1Inline;
